export default "__VITE_ASSET__144d18da__"